import { render, staticRenderFns } from "./PhBbFirstVisitModal.vue?vue&type=template&id=14ef73a0&scoped=true&"
import script from "./PhBbFirstVisitModal.vue?vue&type=script&lang=js&"
export * from "./PhBbFirstVisitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef73a0",
  null
  
)

export default component.exports